// Per-page header pattern used inside the dashboard shell. Renders breadcrumb,
// title, optional subhead, and a right-aligned action area for primary CTAs.

import { Link } from 'react-router-dom'

export function PageHeader({ breadcrumb, title, subhead, actions }) {
  return (
    <header className="border-b border-[var(--color-sandstone)] px-6 py-6">
      {breadcrumb && (
        <nav aria-label="Breadcrumb" className="mb-2 flex flex-wrap items-center gap-1 text-xs">
          {breadcrumb.map((crumb, i) => (
            <span key={`${crumb.label}-${i}`} className="flex items-center gap-1">
              {i > 0 && (
                <span aria-hidden="true" className="text-[var(--color-schist)]">
                  /
                </span>
              )}
              {crumb.to ? (
                <Link
                  to={crumb.to}
                  className="text-[var(--color-schist)] hover:text-[var(--color-terracotta)]"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-[var(--color-slate)]">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-[var(--color-basalt)]">{title}</h1>
          {subhead && <p className="mt-1 text-sm text-[var(--color-schist)]">{subhead}</p>}
        </div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
    </header>
  )
}
